/**
 * Where a floating action button may sit.
 *
 * The bug this fixes: Hub's create FAB was pinned to `bottom-6 right-6 z-50`
 * (mobile only) and the support-chat bubble is pinned to `bottom:20px;
 * right:20px; z-index:9999` from `@wtc/support-chat`. Same corner, and the chat
 * bubble wins on z-index — so on a phone the primary "create" action on every
 * CRM list page was sitting UNDER the chat bubble and could not be tapped.
 *
 * The FAB now stacks ABOVE the reserved chat-bubble area instead of fighting it
 * for the same pixels. The measurements below mirror the support widget's
 * inline styles; if that widget's size or offset changes, change these with it.
 */

/** Support-chat bubble diameter, from `SupportChatWidget`'s inline styles. */
export const SUPPORT_CHAT_BUBBLE_SIZE_PX = 60;

/** Support-chat bubble distance from the viewport bottom. */
export const SUPPORT_CHAT_BUBBLE_BOTTOM_PX = 20;

/** Breathing room between the chat bubble and whatever stacks above it. */
export const FAB_STACK_GAP_PX = 12;

/**
 * Distance from the viewport bottom for a FAB that must clear the support-chat
 * bubble: bubble offset + bubble height + gap.
 */
export const FAB_BOTTOM_OFFSET_PX =
  SUPPORT_CHAT_BUBBLE_BOTTOM_PX + SUPPORT_CHAT_BUBBLE_SIZE_PX + FAB_STACK_GAP_PX;

/**
 * Tailwind positioning for a bottom-right FAB, stacked clear of the support
 * chat bubble and padded for iOS/Android safe areas.
 *
 * Kept as a literal (not an interpolated arbitrary value) because Tailwind
 * scans source text for class names — a computed string would not be generated.
 * The constants above document the arithmetic: 20 + 60 + 12 = 92px = 5.75rem.
 */
export const FAB_POSITION_CLASSES =
  "fixed bottom-[calc(5.75rem+env(safe-area-inset-bottom))] right-[calc(1.5rem+env(safe-area-inset-right))]";
